import NiceModal from '@ebay/nice-modal-react';
import React, { Suspense } from 'react';

import { MODALS } from '@/shared/config/modals';

const ReferralModalLazy = React.lazy(() =>
  import('./ReferralModal').then((m) => ({ default: m.ReferralModal })),
);

NiceModal.register(
  MODALS.REFERRAL,
  NiceModal.create(() => (
    <Suspense fallback={null}>
      <ReferralModalLazy />
    </Suspense>
  )),
);
